import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=439be0f2&scoped=true&"
import script from "./UploadCard.vue?vue&type=script&lang=js&"
export * from "./UploadCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadCard.vue?vue&type=style&index=0&id=439be0f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439be0f2",
  null
  
)

export default component.exports